import brand from '@helpers/brand';
// import fonts from '@helpers/fonts';
import { Device, from, until } from '@helpers/media';
import SectionWrapper from '@stories/Components/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
import RichTextStyles from '../RichText/RichText.styles';
import { ReactComponent as SvgPin } from '@img/icons/location-icon.svg';
import { ReactComponent as SvgPhone } from '@img/icons/telephone-icon.svg';
import { ReactComponent as SvgEnvelope } from '@img/icons/email-icon.svg';
import { cssVar, setCssVar } from '@helpers/cssVar';
import fonts from '@helpers/fonts';
import ParagraphStyles from '@stories/Components/Global/Typography/Paragraph.styles';
const Container = styled(SectionWrapper) `
  ${setCssVar('accentColor2', brand.htaRebrand.green)};
  ${setCssVar('accentColor', brand.htaRebrand.greenBright)};
  ${setCssVar('bgColor', brand.htaRebrand.greenBg)};
  ${setCssVar('fgColor', brand.black)};
  ${setCssVar('fgColorAlt', brand.grey)};

  .theme-apl & {
    ${setCssVar('accentColor', brand.apl.green)};
    ${setCssVar('accentColor2', brand.apl.green)};
    ${setCssVar('bgColor', brand.greyVeryLight)};
    ${setCssVar('fgColor', brand.black)};
    ${setCssVar('fgColorAlt', brand.black)};
  }

  .theme-hh & {
    ${setCssVar('accentColor', brand.hortHouse.green)};
    ${setCssVar('accentColor2', brand.hortHouse.green)};
    ${setCssVar('bgColor', brand.greyVeryLight)};
    ${setCssVar('fgColor', brand.black)};
    ${setCssVar('fgColorAlt', brand.black)};
  }

  display: flex;
  min-height: 300px;
  padding: 32px 0;
`;
const Inner = styled.div `
  position: relative;
  overflow: hidden;
  height: 100%;
  justify-content: center;
  background-color: ${cssVar('bgColor')};
  border-radius: 12px;
  padding: 24px 27px;
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(12, 1fr);

  @media ${from(Device.Tablet)} {
    padding: 20px 30px;
  }

  @media ${from(Device.TabletLarge)} {
    gap: 30px;
    padding: 70px 0;
    border-radius: 24px;
  }
`;
const ContentWrapper = styled.div `
  position: relative;
  grid-column: 2 / span 10;

  @media ${until(Device.TabletLarge)} {
    grid-column: 1 / span 12;
  }
`;
const Title = styled.h2 `
  ${fonts.sourceSansPro.semiBold};
  font-size: 30px;
  line-height: 38px;

  @media ${until(Device.Tablet)} {
    ${fonts.sourceSansPro.bold};
    font-size: 24px;
    line-height: 32px;
  }
`;
const Content = styled.div `
  ${RichTextStyles.contentStyles};
  color: ${cssVar('fgColorAlt')};

  p {
    ${ParagraphStyles.RegularStyles};

    @media ${until(Device.Tablet)} {
      font-size: 18px;
      line-height: 28px;
    }
  }

  a {
    color: ${cssVar('fgColorAlt')};
  }
`;
const InfoGrid = styled.div `
  grid-column: 2 / span 10;
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 12px;

  @media ${from(Device.TabletLarge)} {
    gap: 32px;
  }

  @media ${until(Device.TabletLarge)} {
    grid-column: 1 / span 12;
    margin-top: 30px;
  }
`;
const InfoCol = styled.div `
  display: flex;
  align-items: flex-start;
  grid-column: span 12;

  @media ${from(Device.Tablet)} {
    grid-column: span 4;
  }

  @media ${from(Device.Desktop)} {
    grid-column: span 3;
  }

  @media ${until(Device.Tablet)} {
    position: relative;
  }
`;
const IconHolder = styled.div `
  flex: 0 0 30px;
  height: 100%;
  display: flex;
  align-items: flex-start;

  @media ${from(Device.TabletLarge)} {
    flex: 0 0 43px;    
  }
`;
const InfoColInner = styled.div `
`;
const InfoColContent = styled.div `
  ${RichTextStyles.contentStyles};
  padding-left: 17px;
  color: ${cssVar('fgColorAlt')};

  p {
    margin-bottom: 0;

    &:last-child {
      margin-bottom: 30px;
    }

    @media ${until(Device.Tablet)} {
      font-size: 18px;
      line-height: 24px;
    }
  }
`;
const Link = styled.a `
  ${ParagraphStyles.RegularStyles};
  color: ${cssVar('fgColorAlt')};
  text-decoration: underline;
  display: block;

  padding-left: 17px;

  @media ${until(Device.Tablet)} {
    text-decoration: underline;
    font-size: 18px;
    line-height: 24px;
  }

  &:focus {
    outline: none;
  }

  &:hover,
  &:focus {
    text-decoration: none;
  }
`;
const Pin = styled(SvgPin) `
  color: ${cssVar('accentColor2')};
  transform: translateY(-5px);
  width: 43px;

  @media ${from(Device.DesktopLarge)} {
    transform: translateY(-3px);
  }

  @media ${until(Device.DesktopSmall)} {
    margin: 0 0 16px;  
    width: 30px;
    transform: translateY(0);
  }
`;
const Phone = styled(SvgPhone) `
  color: ${cssVar('accentColor2')};
  transform: translateY(-5px);
  width: 43px;

  @media ${from(Device.DesktopLarge)} {
    transform: translateY(-3px);
  }

  @media ${until(Device.DesktopSmall)} {
    margin: 0 0 16px;    
    width: 30px;
    transform: translateY(0);
  }
`;
const Envelope = styled(SvgEnvelope) `
  color: ${cssVar('accentColor2')};
  transform: translateY(-6px);
  width: 43px;

  @media ${from(Device.DesktopLarge)} {
    transform: translateY(-3px);
  }

  @media ${until(Device.DesktopSmall)} {
    margin: 0 0 16px;  
    width: 30px;
    transform: translateY(0);
  }
`;
export default {
    Container,
    Content,
    ContentWrapper,
    Envelope,
    IconHolder,
    InfoCol,
    InfoColContent,
    InfoColInner,
    InfoGrid,
    Inner,
    Link,
    Phone,
    Pin,
    Title,
};
